import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import FormFieldErrors from '@@client/components/FormFieldErrors';
import { classnames } from '@@client/lib/classes';
export default function FormField(_ref) {
  var children = _ref.children,
      inputId = _ref.inputId,
      errorId = _ref.errorId,
      title = _ref.title,
      description = _ref.description,
      errors = _ref.errors,
      className = _ref.className,
      titleClassName = _ref.titleClassName,
      _ref$required = _ref.required,
      required = _ref$required === void 0 ? false : _ref$required,
      _ref$childrenFirst = _ref.childrenFirst,
      childrenFirst = _ref$childrenFirst === void 0 ? false : _ref$childrenFirst;
  var haveErrors = errors && errors.length;
  var classNames = classnames(['field', haveErrors ? 'has-errors' : null, required ? 'is-required' : null, className]);
  return /*#__PURE__*/_jsxs("div", {
    className: classNames,
    children: [childrenFirst ? children : undefined, title ? /*#__PURE__*/_jsx("label", {
      className: titleClassName,
      htmlFor: inputId,
      children: title
    }) : null, /*#__PURE__*/_jsx("div", {
      className: "field-input",
      children: !childrenFirst ? children : undefined
    }), /*#__PURE__*/_jsx(FormFieldErrors, {
      id: errorId,
      errors: errors
    }), description ? /*#__PURE__*/_jsx("div", {
      className: "description",
      children: description
    }) : '']
  });
}